export class MarcaVehiculo{
    constructor(
        public id: number,
        public nombre: string,
        public descripcion: string,
        public isDeleted: boolean,
        public isVW: boolean
    ){}
}